import React from 'react';
import { connect } from 'react-redux';
import { ContentTileWithImageAndCard } from '@americanexpress/aqx-components';
import { LazyLoad } from 'acq-components/lib/services/performance/LazyLoad/LazyLoad';
import { browserHistory } from 'react-router';
import get from 'lodash.get';

import removeTags from 'service_modules/utils/text-remove-tags';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { mapUrlWithDtmLinkQuery } from 'service_modules/models/dtm-tagging';
import { getPdpCrossSellBannerData } from 'page_modules/business-pdp/redux';
import withPropTestingData from 'src/universal/components/WithPropTestingData';
import { DATA_TYPES } from 'src/universal/redux/propTesting';

import styles from './__styles__/index.scss?modules';

const PropsTestedCrossSellBanner = withPropTestingData(
  ContentTileWithImageAndCard,
  'ContentTileWithImageAndCard',
  DATA_TYPES.cardData
);

const XSell = ({ xSellBannerData = {} }) => {
  const { imageUrl, header, description, learnMore, assets } = xSellBannerData;
  const allowRender = !!imageUrl && assets;

  return (
    allowRender && (
      <LazyLoad offset={600}>
        <div className={styles.bannerContainer}>
          <div>
            <PropsTestedCrossSellBanner
              data={{
                cardImage: imageUrl,
                cardImageAlt: removeTags(header),
                title: header,
                text: description,
                button: {
                  text: learnMore.text,
                  onClick: () => {
                    sendDTMClickEvent(learnMore.dtm);
                    const formattedUrl = mapUrlWithDtmLinkQuery(
                      get(learnMore, 'url') || '',
                      get(learnMore, 'dtm') || {}
                    );
                    browserHistory.push(formattedUrl);
                  }
                },
                backgroundCardImage: {
                  sm: assets[0].url,
                  md: assets[0].url,
                  lg: assets[1].url
                }
              }}
            />
          </div>
        </div>
      </LazyLoad>
    )
  );
};

const mapStateToProps = state => ({
  xSellBannerData: getPdpCrossSellBannerData(state)
});

export const XSellBanner = React.memo(connect(mapStateToProps)(XSell));
